
export default function CostEstimation() {
  const factors = [
    {
      icon: 'ri-ruler-line',
      title: 'Tamaño del piso',
      description: 'El metraje y número de habitaciones influyen directamente en el coste del servicio.'
    },
    {
      icon: 'ri-stack-line',
      title: 'Volumen de enseres',
      description: 'La cantidad de muebles, electrodomésticos y objetos a retirar determina el trabajo necesario.'
    },
    {
      icon: 'ri-stairs-line',
      title: 'Accesibilidad',
      description: 'La planta del edificio, disponibilidad de ascensor y accesos afectan la logística.'
    },
    {
      icon: 'ri-timer-line',
      title: 'Urgencia del servicio',
      description: 'Los servicios urgentes o en fechas específicas pueden tener un coste adicional.'
    }
  ];

  const priceRanges = [
    {
      type: 'Piso pequeño',
      size: '40-60 m²',
      price: 'Desde 250€',
      features: ['1-2 habitaciones', 'Vaciado básico', 'Gestión de residuos']
    },
    {
      type: 'Piso mediano',
      size: '60-90 m²',
      price: 'Desde 400€',
      features: ['2-3 habitaciones', 'Vaciado completo', 'Desmontaje incluido'],
      highlighted: true
    },
    {
      type: 'Piso grande',
      size: '90+ m²',
      price: 'Desde 600€',
      features: ['3+ habitaciones', 'Vaciado integral', 'Servicios adicionales']
    }
  ];

  return (
    <section id="costes" className="py-12 sm:py-16 md:py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Estimación de costes
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Precios transparentes y competitivos. El coste final depende de varios factores que evaluamos personalmente.
          </p>
        </div>

        <div className="mb-12 sm:mb-16">
          <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8 text-center px-2">
            Factores que influyen en el precio
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {factors.map((factor, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-5 sm:p-6 text-center shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className={`${factor.icon} text-xl sm:text-2xl text-teal-600`}></i>
                </div>
                <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
                  {factor.title}
                </h4>
                <p className="text-xs sm:text-sm text-gray-600">
                  {factor.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8 text-center px-2">
            Rangos de precio orientativos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {priceRanges.map((range, index) => (
              <div
                key={index}
                className={`rounded-xl p-6 sm:p-8 ${
                  range.highlighted
                    ? 'bg-teal-600 text-white shadow-xl md:transform md:scale-105'
                    : 'bg-white text-gray-900 shadow-sm'
                }`}
              >
                <div className="text-center mb-5 sm:mb-6">
                  <h4 className={`text-xl sm:text-2xl font-bold mb-2 ${range.highlighted ? 'text-white' : 'text-gray-900'}`}>
                    {range.type}
                  </h4>
                  <p className={`text-xs sm:text-sm mb-3 sm:mb-4 ${range.highlighted ? 'text-teal-100' : 'text-gray-600'}`}>
                    {range.size}
                  </p>
                  <div className={`text-3xl sm:text-4xl font-bold ${range.highlighted ? 'text-white' : 'text-teal-600'}`}>
                    {range.price}
                  </div>
                </div>
                <ul className="space-y-2 sm:space-y-3">
                  {range.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 sm:gap-3">
                      <i className={`ri-check-line text-lg sm:text-xl flex-shrink-0 ${range.highlighted ? 'text-teal-200' : 'text-teal-600'}`}></i>
                      <span className={`text-xs sm:text-sm ${range.highlighted ? 'text-white' : 'text-gray-600'}`}>
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <p className="text-center text-gray-600 mt-6 sm:mt-8 text-xs sm:text-sm px-4">
            * Los precios son orientativos. Solicita un presupuesto personalizado sin compromiso.
          </p>
        </div>
      </div>
    </section>
  );
}
